import {useEffect, useRef, useState} from 'react';

export function useHover() {
  const [value, setValue] = useState(false);
  const ref = useRef<Element>(null);
  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);
  const handleMouseWheel = () => setValue(false);

  useEffect(
    () => {
      const node = ref.current;

      if (node) {
        node.parentNode?.addEventListener('mousewheel', handleMouseWheel);
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);

        return () => {
          node.parentNode?.removeEventListener('mousewheel', handleMouseWheel);
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseout', handleMouseOut);
        };
      }
    },
    [ref], // Recall only if ref changes
  );

  return [ref, value];
}
